export const loadScript = (scriptUrl: string, scriptID?: string, loadAsync?: boolean) =>
  new Promise((resolve, reject) => {
    if ((scriptID && !document.getElementById(scriptID)) || !scriptID) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = scriptUrl;
      if (loadAsync) {
        script.async = true;
        script.defer = true;
      }
      if (scriptID) {
        script.id = scriptID;
      }
      const documentHead = document.getElementsByTagName('head')[0];
      documentHead.appendChild(script);

      script.onload = () => resolve(true);
      script.onerror = (e: any) => {
        // eslint-disable-next-line
        console.error(`Error loading script: ${scriptUrl}`, e);
        reject();
      };
    } else {
      resolve(true);
    }
  });
